import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { RendererProvider } from '@bxp-framework/components';
import { useAnalytics, PlaceholderContext } from '../../components';
import { getColorsFromBackgroundField } from '../../styles';
import { renderViewModels, renderViewModel } from '../../render-view-model';
export default function Page({ model }) {
    const { sendPageEvent } = useAnalytics();
    const { title, route, variant, metaDescription, sections = [], background, cookieBanner } = model.content;
    useEffect(() => {
        sendPageEvent('', {
            path: route.content.path,
            title,
            variant
        });
    }, [route.content.path, sendPageEvent]);
    const colors = getColorsFromBackgroundField(background);
    return (React.createElement(RendererProvider, { renderer: renderViewModel },
        React.createElement(Helmet, null,
            React.createElement("title", null, title),
            React.createElement("meta", { charSet: "utf-8" }),
            React.createElement("meta", { name: "description", content: metaDescription }),
            React.createElement("meta", { name: "viewport", content: "width=device-width, initial-scale=1, shrink-to-fit=no" }),
            ((colors === null || colors === void 0 ? void 0 : colors.background) || (colors === null || colors === void 0 ? void 0 : colors.color)) && (React.createElement("style", { type: "text/css" }, `
            body {
              ${colors.background ? `background: ${colors.background};` : ''}
              ${colors.color ? `color: ${colors.color};` : ''}
          `))),
        React.createElement(PlaceholderContext.Provider, { value: "page" },
            renderViewModels(sections),
            cookieBanner && renderViewModel(cookieBanner))));
}
//# sourceMappingURL=Page.js.map